import { useDisclosure, Card, Spinner, Input, InputGroup, Button} from "@chakra-ui/react";
import { Flex, Heading, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import "../../App.css"
import { useAuth } from "@viabl/echo-web-client-core";
import { useCache } from "../../context/CacheContext";
import useForceUpdate from "use-force-update";
import { useWebHelper } from "@viabl/echo-web-client-core";
import { GrTrigger } from "react-icons/gr";
import { useEnvironment } from "../../context/webHelpers";
import { CodeEditor } from "../../components/code/codeEditor";
import GoBack from "../../components/goBack";
import { ShowSteps } from "../../components/workflows/showSteps";
import { useColorMode } from "../../components/ui/color-mode";
import { LuCopy, LuCopyCheck } from "react-icons/lu";
import { Tooltip } from "../../components/ui/tooltip"

export interface User {
    id: string,
    account_id: string,
    applications: []
    created: string,
    created_by_id: string
    department: string
    email_address: string,
    first_name: string,
    last_name: string,
    full_name: string,
    groups: [],
    initiated: boolean,
    status: number,
    type: Type,
    type_id: string,
    user_type_id: string,
}

export interface Type {
    id: string,
    name: string,
}
interface IPageContainerProps {
    pageTitle: string,
    children: React.ReactNode;
}
interface IWorkResult {
    AddressLine: string,
    AllocationId: string,
    AllocationStatus: number,
    AppointmentDate: string,
    AppointmentId: string,
    DisciplineId: string,
    EndTime: string,
    EngineerId: string,
    EngineerName: string,
    Expected: string,
    IsAccepted: boolean,
    IsAccountWork: boolean,
    IsOnOrder: boolean,
    IsOrderLate: boolean,
    JobNumber: string,
    PostCode: string,
    StartTime: string,
    value: number,
    cb: Function,
    ringmaster: string,
    disciplineName: string,
    disciplineAccent: string,
    isActive: boolean,
    RouteIndex: number,

}

interface IAllocationModel {
    accepted: boolean,
    appointment_id: string
}
interface IUserTypes {
    id: string,
    name: string,
}
interface IWorkflows {
    description: string,
    event_id: string,
    id: string,
    initializer_code_id: string,
    name: string,
}
export interface IWorkflowStep {
    id: string;
    created: string;
    created_by_id: string;
    created_by_name: string;
    updated: string;
    updated_by_id: string;
    updated_by_name: string;
    name: string;
    description: string;
    definition_id: string;
    index: number;
    cooldown_time: string;
    estimated_length: string | null;
    maximum_length: string | null;
    tag: string | null;
    execution_type: string;
    code_id: string;
    events: event[];
    twilio_task_type: string | null;
    twilio_task_type_key: string | null;
    time_profile_id: string;
}
export interface event {

    event_id: string;
    step_id: string;
    code_definition: string;
}
interface Timeprofiles {
    id: string,
    is_bank_holiday_aware: boolean,
    name: string,
    days: Day[]
}
interface Day {
    day: string,
    end_time: string,
    id: string,
    start_time: string,
}
export const ViewWorkflow = () => {
    const [ignore, setIgnore] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [engineerList, setEngineerList] = useState<any[]>([]);
    const [newEngineerList, setNewEngineerList] = useState<any[]>([]);
    const [defaultView, setDefaultView] = useState<boolean>(true);
    const [search, setSearch] = useState<string>('');
    const [page, setPage] = useState<number>(0);
    const [rows, setRows] = useState<IWorkflows[]>([]);
    const [tableHeight, setTableHeight] = useState('5100px')
    const [maxPages, setMaxPages] = useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [userTypes, setUserTypes] = useState<IUserTypes[]>([]);
    const [selectedType, setSelectedType] = useState<string>("803130a7-7a5c-43d3-b850-bf8ecba20cd9");
    const [workflow, setWorkflow] = useState<IWorkflows>();
    const [copied, setCopied] = useState<boolean>(false);
    const [copiedEvent, setCopiedEvent] = useState<boolean>(false);
    const { colorMode, toggleColorMode } = useColorMode();
    const [stepsLoaded, setStepsLoaded] = useState<boolean>(false);

    const [timeprofiles, setTimeprofiles] = useState<Timeprofiles[]>([]);

    const [steps, setSteps] = useState<IWorkflowStep[]>();
    const { workflow_id, environment } = useParams();


    const { open, onToggle } = useDisclosure()
    const auth = useAuth();
    const CacheContext = useCache();
    // @ts-ignore
    

    const webHelpers = useWebHelper();
    const forceUpdate = useForceUpdate();
    let navigate = useNavigate();

    useEffect(() => {

    }, [engineerList]);

    const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
        setSearch(e.currentTarget.value);
    }
    const handleChangeRowsPerPage = (event: React.ChangeEvent<any>) => {
        setLoading(true);
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        if (webHelpers.selectedEnvironment === null || webHelpers.selectedEnvironment === undefined) {
            console.log("environment is null?")
        }
    }, [])
    useEffect(() => {
        setCopied(false);
        setCopiedEvent(false);
        if (environment !== undefined) {
            webHelpers.SetEnvironmentById(environment);
        }
    }, []);

    function getWorkflow() {
        console.log(webHelpers.selectedEnvironment.id);
        if (environment !== undefined) {
            webHelpers.SetEnvironmentById(environment);
        }

        if (webHelpers.selectedEnvironment.id !== undefined) {
            webHelpers.GetAsync('/api/workflow/' + workflow_id, 'helios-api').then((data: any) => {
                if (data === undefined || data === null || data.status === 400) {
                    console.log('unable to fetch workflow', { 'variant': 'error' })
                    // setRows(defaultWorkflow);
                }
                else {
                    setWorkflow(data);

                    getStepsDefinition(data);
                    getTimeprofiles();
                }
            }).catch((error) => {
                console.log("caught error", error);
            })
        }

    }
    function getStepsDefinition(Workflow: IWorkflows) {
        if (Workflow !== undefined && Workflow !== null) {
            webHelpers.GetAsync("/api/workflow/" + Workflow?.id + "/steps", "helios-api").then((data) => {
                if (data === undefined || data == null) {
                    console.log("Unable to fetch steps from API", {
                        variant: "error",
                    });
                } else {
                    setSteps(Object.values(data));
                }
            }
            );
        }
        else {
            console.log("workflow is null!")
        }
    }
    function getTimeprofiles() {
        //webHelpers.get('/api/workflow/timeprofiles/?page=' + (page + 1) + '&pageSize=' + rowsPerPage, environment, 'helios-api', token, (data: any) => {
        webHelpers.GetAsync('/api/workflow/timeprofiles', 'helios-api').then((data: any) => {
            if (data === undefined || data === null || data.status === 400) {
                console.log("Could not fetch time profiles");
            }
            else {
                //@ts-ignore
                setTimeprofiles(Object.values(data));
                setLoading(false);
                //setMaxPages(data.maximum_pages)
            }
        })
    }

    useEffect(() => {
        setLoading(true);
        getWorkflow()

    }, [search, page, rowsPerPage, selectedType, webHelpers.selectedEnvironment]);

    const handleCopy = (id: string) => {
        navigator.clipboard.writeText(id);
        setCopied(true);
        setTimeout((() => setCopied(false)), 2000);
    }

    const handleEventCopy = (id: string) => {
        navigator.clipboard.writeText(id);
        setCopiedEvent(true);
        setTimeout((() => setCopiedEvent(false)), 2000);
    }


    const refresh = () => {
        setIgnore(true);
        getWorkflow();
        setLoading(true);

    }
    useEffect(() => {
        window.addEventListener('workflowStepsLoaded', () => {
            setStepsLoaded(true);
        });
        setStepsLoaded(false);
    }, []);
    return (

        <>
            {(workflow !== null && workflow !== undefined) &&
                // <ScaleFade initialScale={1} in={!loading}>
                <>
                    <Heading marginTop={"20px"} color={colorMode === 'light' ? "AbleBlue" : "AbleYellow"} as={"i"} justifySelf={"center"} display={"block"} fontWeight={"lighter"}
                    >{"Managing Workflow: " + String(workflow.name.slice(0)[0].toUpperCase()) + String(workflow.name.slice(1))} </Heading>
                    <Flex direction={'row'} h='calc(100vh - 250px)' justifyContent={"center"} className="animate__animated animate__fadeIn animate__faster" display={stepsLoaded ? "flex" : "none"}> {/* Bit of a bodge for now - have to manually set height based on hardcoded header height */}
                        {/* table to show list of users */}
                        {!loading ?
                            <Flex justifyContent={"space-around"} marginTop={"50px"}>
                                <Flex marginBottom={"10px"} marginLeft={"-105px"} justifyContent={"center"} marginTop={"0px"} position={"relative"} top={-10} right={0}>
                                    <GoBack goBackTo="/workflows" />
                                </Flex>
                                <Flex direction={"row"}>
                                    <Card.Root height={"-webkit-fit-content"} bg={"backgroundLightGrey"} borderRightRadius={0} padding={"10px"} marginRight={"-1px"}>
                                        <Card.Header>
                                            <Text as={"b"} color={colorMode === 'light' ? "AbleBlue" : "white"}>Workflow Details</Text>
                                            <Text marginBottom={"10px"}>{workflow?.description}</Text>
                                        </Card.Header>
                                        <Card.Body paddingTop={"0px"}>
                                            <InputGroup startAddon={"ID"} startAddonProps={{ borderColor: "backgroundDarkGrey", borderWidth: "2px" }} endAddonProps={{ width: "10px", borderColor: "backgroundDarkGrey", borderWidth: "2px" }} endAddon={
                                                <Tooltip closeOnClick={false} content={copied ? "Copied!" : "Copy ID"} positioning={{ placement: "top" }}>
                                                    <Button size={"sm"} marginLeft={"-17px"} height={"40px"} maxW={"1px"} paddingRight={"0px"} paddingLeft={"0px"} color={"primaryTextInverted"} bg={"rgba(0,0,0,0)"} onClick={() => handleCopy(workflow?.id)}>
                                                        {copied ? <LuCopyCheck /> : <LuCopy />}
                                                    </Button>
                                                </Tooltip>
                                            }>
                                                <Input borderColor={"backgroundDarkGrey"} borderWidth={"2px"} height={"45px"} bgColor={"backgroundDarkGrey"} placeholder={workflow?.id} value={workflow?.id} contentEditable={false}>
                                                </Input>
                                            </InputGroup>
                                            <InputGroup marginTop={"10px"} startAddon={<GrTrigger />} startAddonProps={{ borderColor: "backgroundDarkGrey", borderWidth: "2px" }} endAddonProps={{ width: "10px", borderColor: "backgroundDarkGrey", borderWidth: "2px" }} endAddon={
                                                <Tooltip closeOnClick={false} content={copiedEvent ? "Copied!" : "Copy Event ID"} positioning={{ placement: "top" }}>
                                                    <Button size={"sm"} marginLeft={"-17px"} height={"40px"} maxW={"1px"} paddingRight={"0px"} paddingLeft={"0px"} color={"primaryTextInverted"} bg={"rgba(0,0,0,0)"} onClick={() => handleEventCopy(workflow?.event_id)}>
                                                        {copiedEvent ? <LuCopyCheck /> : <LuCopy width={"10px"} />}
                                                    </Button>
                                                </Tooltip>
                                            }>
                                                <Input borderColor={"backgroundDarkGrey"} borderWidth={"2px"} height={"45px"} bgColor={"backgroundDarkGrey"} placeholder={workflow?.event_id} value={workflow?.event_id} contentEditable={false}>
                                                </Input>
                                            </InputGroup>
                                            <Flex w={"96%"} marginTop={"10px"}>
                                                <CodeEditor stepFriendlyName={workflow.name} code_id={workflow?.initializer_code_id} buttonText="Edit Initialiser Code" mode="" cb={undefined} intital_value={undefined} quick_outcome_code_id={null} />
                                            </Flex>
                                        </Card.Body>
                                    </Card.Root>
                                    <Flex className="animate__animated animate__fadeIn" display={stepsLoaded ? "flex" : "none"}>
                                        <ShowSteps />
                                    </Flex>
                                </Flex>
                            </Flex>
                            :
                            <Flex direction={"row"} justifyContent={"center"} width={"100%"} marginTop={"5%"}>
                                <Spinner color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} marginTop={"100px"} marginBottom={"100px"} size={"xl"} />
                            </Flex>

                        }

                        {/* <ScaleFade initialScale={0.1} in={defaultView}>
                        </ScaleFade> */}

                    </Flex>
                    <Flex direction={'row'} h='calc(100vh - 250px)' justifyContent={"center"} className="animate__animated animate__fadeIn animate__faster" display={!stepsLoaded ? "flex" : "none"}>
                        <Spinner color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} marginTop={"100px"} marginBottom={"100px"} size={"xl"} />
                    </Flex>

                </>
            }

        </>
    )
}
